// The UNSAVED CHANGES pop-up's "Save & Update" runs the page save. When that
// save stops on required fields, Update Member Form.dc.html (errPop
// fromLeave, L1427-1429, L3049) shows the REQUIRED FIELDS MISSING pop-up with
// a "Leave Without Saving" button that still goes to the page the user chose.
// The two pop-ups are separate components, so the chosen page waits here.

export type MissingFieldsPendingLeave = {
  /** Goes on to the page the user chose, without saving. */
  leave: () => void;
  /** Stays on this page (the user closed the pop-up). */
  stay: () => void;
};

let pendingLeave: MissingFieldsPendingLeave | null = null;
let openDialogCount = 0;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((listener) => listener());

export const subscribeMissingFieldsPendingLeave = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getMissingFieldsPendingLeave = () => pendingLeave;

export const setMissingFieldsPendingLeave = (next: MissingFieldsPendingLeave | null) => {
  pendingLeave = next;
  emit();
};

/** Takes the waiting navigation (once) and clears it. */
export const takeMissingFieldsPendingLeave = () => {
  const current = pendingLeave;
  if (current) setMissingFieldsPendingLeave(null);
  return current;
};

export const markMissingFieldsDialogOpen = () => {
  openDialogCount += 1;
  return () => {
    openDialogCount = Math.max(0, openDialogCount - 1);
  };
};

export const isMissingFieldsDialogOpen = () => openDialogCount > 0;
